export enum FirebaseFunctionsStatusCodes {
  NOT_FOUND = 'functions/not-found',
}
